import React from 'react'
import { Input, InputDiv, Label, ParamMainFieldsContainer } from '../../CreateCertificate/style'
import { ParamType } from '..'
import SelectCertificateTypeInCertificate from '../../../../../components/Certificates/SelectItem/CertificateType'

interface PropsType {
  param: ParamType
  setParam: React.Dispatch<React.SetStateAction<ParamType>>
}

interface FieldsType {
  label: string
  key: keyof ParamType
  isNested?: boolean
}

const basicFields:FieldsType[] = [
  { label: 'Nome', key: 'name' },
  { label: 'Classe', key: 'class' },
  { label: 'Família', key: 'family' },
  { label: 'ASTM', key: 'astm', isNested: true },
  { label: 'UNS', key: 'uns', isNested: true },
  { label: 'DIN', key: 'din', isNested: true },
  { label: 'AISI', key: 'aisi', isNested: true },
  { label: 'Outras', key: 'others', isNested: true },
]

const ParamMainFields:React.FC<PropsType> = ({param, setParam}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const key = e.target.name as keyof ParamType
    setParam(prev => ({
      ...prev,
      [key]: e.target.value
    }))
  }
  
  return (
    <ParamMainFieldsContainer>
      {basicFields.filter(field => !field.isNested).map((field, index) => 
        <>
        {index === 1 ?
        <>
          <SelectCertificateTypeInCertificate param={param} setParam={setParam} />
          <InputDiv key={index}>
            <Label>{field.label}</Label>
            <Input
              autoComplete='off'
              name={field.key}
              placeholder='Digite aqui'
              onChange={handleChange}
              type='text'
              value={String(param[field.key]) || ''}
            />
          </InputDiv>
        </>
        :
          <InputDiv key={index}>
            <Label>{field.label}</Label>
            <Input
              autoComplete='off'
              name={field.key}
              placeholder='Digite aqui'
              onChange={handleChange}
              type='text'
              value={String(param[field.key]) || ''}
            />
          </InputDiv>
        }
        </>
      )}
      <InputDiv className='itemParent'>
        {basicFields.filter(field => field.isNested).map((field, index) => 
          <InputDiv key={index}>
            <Label>{field.label}</Label>
            <Input
              autoComplete='off'
              name={field.key}
              placeholder='Digite aqui'
              onChange={handleChange}
              type='text'
              value={String(param[field.key]) || ''}
            />
          </InputDiv>
      )}
      </InputDiv>
    </ParamMainFieldsContainer>
  )
}

export default ParamMainFields